import { defineComponent as _defineComponent } from 'vue'
import { INoticeInfoData } from "@/domain/entities/bbs";
import { ref, PropType, onMounted } from "vue";
import dayjs from "dayjs";
import DOMPurify from "dompurify";
import { useValidateUrlLink } from "@/composables/shared/useValidateUrlLink";
import ZoomControl from "@/components/shared/ZoomControl.vue";
import { useRoute } from "vue-router";

const __default__ = {
  name: "NoticeModal",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  noticeInfos: {
    type: Array as PropType<INoticeInfoData[]>,
    required: true,
  },
},
  emits: ["onClose"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const utc = require("dayjs/plugin/utc");
dayjs.extend(utc);

const props = __props;

const emit = __emit;

const route = useRoute();

const hasText = (content: string) => {
  // 모든 태그를 제거하여 순수한 텍스트만 남김
  const textWithoutTags = content.replace(/<[^>]*>/g, "").trim();
  // 순수한 텍스트가 남아 있으면 true를 반환
  return textWithoutTags.length > 0;
};

const nowNoticeIndex = ref(0);
const onClickNoMoreShowForThreeDays = (noticeInfo: INoticeInfoData) => {
  setCookie(noticeInfo.id);
  onClickClose();
};

const onClickClose = () => {
  route.meta.onBackHandlerList.pop();
  if (nowNoticeIndex.value < props.noticeInfos.length - 1) {
    nowNoticeIndex.value += 1;
    return;
  }
  nowNoticeIndex.value = -1;
};

const onAfterLeave = () => {
  if (nowNoticeIndex.value === -1) {
    emit("onClose");
  }
};

const setCookie = (key: string) => {
  const nowDate = dayjs().format("YYYY-MM-DD HH:mm:ss");
  const expireDate = dayjs()
    .add(2, "day")
    .set("hour", 23)
    .set("minute", 59)
    .set("second", 59)
    .utc()
    .format("ddd, D MMM YYYY HH:mm:ss UTC");
  document.cookie = `${key}=${nowDate}; expires=${expireDate}; path=/`;
};

/** url 링크 유효성 검사 */
const { validateUrlLink } = useValidateUrlLink();

onMounted(() => {
  props.noticeInfos.forEach(() => {
    route.meta.onBackHandlerList.push(onClickClose);
  });
});

const __returned__ = { utc, props, emit, route, hasText, nowNoticeIndex, onClickNoMoreShowForThreeDays, onClickClose, onAfterLeave, setCookie, validateUrlLink, get DOMPurify() { return DOMPurify }, ZoomControl }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})